module.exports = __webpack_public_path__ + "media/images/emblems/Jaberg-coat_of_arms-b8ba9108ec35c5e0c46af8bc2335f7cf.svg";